// The weeks along the top of a week page on a phone (PhoneWeek.dc.html, its "Weeks" nav), in place of
// the product's menu: W1 to W6, the week they're on filled, the weeks not open yet faded. A week
// that has opened is a link to it.
import { Link } from '../lib/router.jsx'
import { chipLabel, isReleased, moduleRecordings, numberedModules } from './model.js'

export function WeekChips({ product, data, current }) {
  const mods = numberedModules(data)
  if (!mods.length) return null
  return (
    <nav className="pp-weeks" aria-label="Weeks">
      {mods.map(m => {
        const open = moduleRecordings(data, m.id).some(r => isReleased(data, r.id))
        const label = chipLabel(m)
        if (m.id === current?.id) return <span key={m.id} className="pp-week pp-week--on" aria-current="page" aria-label={m.label}>{label}</span>
        return open
          ? <Link key={m.id} to={`${product.path}/${m.key}`} className="pp-week" aria-label={m.label}>{label}</Link>
          : <span key={m.id} className="pp-week pp-week--later" aria-label={`${m.label}, not open yet`}>{label}</span>
      })}
    </nav>
  )
}
